/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/question'
export default icon
